import { useTheme } from '@mui/material/styles';
import {
  buildDefaultQualityMinimapGradientStops,
  buildQualityKpiIncidentGradientStops,
  getQualityStatusColors,
} from './consts';

/**
 * Resolves stream-quality status colors and derived gradient stops for the active MUI palette mode.
 */
export function useQualityStatusColors() {
  const { palette } = useTheme();
  const mode = palette.mode === 'dark' ? 'dark' : 'light';
  const statusColors = getQualityStatusColors(mode);

  return {
    statusColors,
    minimapGradientStops: buildDefaultQualityMinimapGradientStops(statusColors),
    kpiIncidentGradientStops: buildQualityKpiIncidentGradientStops(statusColors),
  };
}
